// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-main[data-v-dc916270]{min-height:100%}.chat-section[data-v-dc916270]{width:100%}", ""]);
// Exports
module.exports = exports;
